import React from 'react';
import { FormBuilder } from 'commons-ui';
import useCreate from './useCreate';
import { NOTICE_FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, noticeValidationSchema } from '../../utils/formConfig';

const CreateNotice: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useCreate();

	return (
		<FormBuilder
			data={data}
			mode='create'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			validationSchema={noticeValidationSchema}
			setShowLoader={setShowLoader}
			fieldConfig={NOTICE_FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG}
			dependencies={[]}
		/>
	);
};

export default CreateNotice;
